// chakra imports
import { Box, Flex, Stack } from "@chakra-ui/react";
//   Custom components
import Brand from "components/sidebar/components/Brand";
import Links from "components/sidebar/components/Links";
import UserProfileTile from "components/sidebar/components/UserProfileTile";
import React from "react";

// FUNCTIONS

function SidebarContent(props) {
  const { routes } = props;
  // SIDEBAR
  return (
    <Flex direction='column' height='100%' pt='25px' px="16px" borderRadius='30px'>
      <Brand />
      <Stack direction='column' mb='auto' mt='8px'>
        <Box ps='0px' pe='0px'>
          <Links routes={routes} />
        </Box>
      </Stack>
      <UserProfileTile />
    </Flex>
  );
}

export default SidebarContent;
